import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { CSVLink } from 'react-csv';

function ExpenseReport() {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ start: '', end: '' });

  useEffect(() => {
    const params = {};
    if (filters.start) params.start = filters.start;
    if (filters.end) params.end = filters.end;
    axios.get('/reports/expenses', { params }).then(res => setData(res.data));
  }, [filters]);

  const total = data.reduce((sum, r) => sum + r.amount, 0);

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Expense Report</h2>
        <div className="flex gap-2 mb-4">
          <input type="date" className="border p-2" value={filters.start} onChange={e => setFilters({ ...filters, start: e.target.value })} />
          <input type="date" className="border p-2" value={filters.end} onChange={e => setFilters({ ...filters, end: e.target.value })} />
          <CSVLink data={data} filename="expense-report.csv" className="bg-green-600 text-white px-4 py-2 rounded">Export CSV</CSVLink>
        </div>
        <table className="table-auto w-full text-left border mb-4">
          <thead><tr><th className="p-2 border">Date</th><th className="p-2 border">Category</th><th className="p-2 border">Amount</th></tr></thead>
          <tbody>
            {data.map(r => (
              <tr key={r.id}>
                <td className="p-2 border">{new Date(r.expense_date).toLocaleDateString()}</td>
                <td className="p-2 border">{r.category}</td>
                <td className="p-2 border">${r.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="font-bold">Total Expenses: ${total.toFixed(2)}</p>
      </div>
    </div>
  );
}
export default ExpenseReport;